import { Service } from '@angular/core';
import { Subject } from 'rxjs';

@Service()
export class PreventScrollService {

  isEnabled$ = new Subject<boolean>();

  constructor() { }
}
